// ? 全局默认配置项

// 首页地址（默认）
export const HOME_URL: string = "/home";

// 登录页地址（默认）
export const LOGIN_URL: string = "/verifylogin";

// 默认主题颜色
export const DEFAULT_PRIMARY: string = "#2A82E4";

// 路由白名单地址（必须是本地存在的路由 staticRouter.ts 中）
export const STATIC_ROUTER_WHITE_LIST: string[] = ["/500", "/400", "/403", "/404"];

// 路由动态白名单地址
export const ROUTER_WHITE_LIST: string[] = [];

// 高德地图 key
export const AMAP_MAP_KEY: string = "";

// 百度地图 key
export const BAIDU_MAP_KEY: string = "";

export const CodeWhitelist: string[] = ["/share"];
